import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" style={{
    enableBackground: "new"
  }} id="svg7384" viewBox="0 0 16 16" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g transform="translate(-32,-91.999995)" id="layer10" /><g transform="translate(-32,-27.999995)" id="layer1" /><g transform="translate(-32,-91.999995)" id="layer11" /><g transform="translate(-32,-27.999995)" id="layer7" /><g transform="translate(-32,-27.999995)" id="layer6" /><g transform="translate(-32,-27.999995)" id="layer5" /><g transform="translate(-32,-27.999995)" id="layer9" /><g transform="translate(-32,-27.999995)" id="layer2"><path id="path3434-5" d="m 37.46875,28.039062 c -0.488278,10e-7 -0.794026,0.213658 -1.029297,0.453126 C 36.204182,28.731655 36,29.046428 36,29.519531 v 0.501953 H 34 V 43.9375 l 12.001953,0.002 V 42.941406 30.021484 H 44 v -0.390625 -0.02734 c -0.02404,-0.430715 -0.181757,-0.733579 -0.417969,-1.011719 -0.236212,-0.278141 -0.620819,-0.582745 -1.197265,-0.550781 l 0.05469,-0.002 z m 0.529297,1.996094 4.005859,0.002 v 1.980469 h 2 v 9.923828 h -8.007812 v -9.923828 h 2.001953 z" style={{
        color: "#bebebe",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1.99676907,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        marker: "none",
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path id="path12871-7" d="m 40.957031,33.001953 a 1.0001,1.0001 0 0 0 -0.664062,0.291016 l -3,3 A 1.0001,1.0001 0 0 0 38,38 h 0.984375 l 0.169922,0.002 -0.980469,1.433594 a 1.0001,1.0001 0 0 0 1.533203,1.271484 l 3,-3 A 1.0001,1.0001 0 0 0 42,36 h -1.130859 l 0.96289,-1.445312 a 1.0001,1.0001 0 0 0 -0.875,-1.552735 z" style={{
        color: "#bebebe",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        marker: "none",
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "new"
      }} /><path id="rect12928" d="m 37,36.999996 h 1 v 1 h -1 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "square",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 1,
        strokeOpacity: 1
      }} /><path id="rect12930" d="m 41,32.999996 h 1 v 1 h -1 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "square",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 1,
        strokeOpacity: 1
      }} /><path id="rect12932" d="m 38,39.999996 h 1 v 1 h -1 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "square",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 1,
        strokeOpacity: 1
      }} /><path id="rect12934" d="m 42,35.999996 h 1 v 1 h -1 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "square",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 1,
        strokeOpacity: 1
      }} /></g><g transform="translate(-32,-27.999995)" id="layer8" /><g transform="translate(-32,-27.999995)" id="layer3" /><g transform="translate(-32,-27.999995)" id="layer4" /></svg>;
}

export default SvgComponent;